import { storageRepository, uaParser } from '@betgames/bg-tools';

class ABTesting {
    private readonly TEST_NAMES = {
        LENNY_SPEED_DESKTOP: 'LENNY_SPEED_2_DESKTOP',
        LENNY_SPEED_MOBILE: 'LENNY_SPEED_2_MOBILE',
    };

    private readonly DEFAULT_VARIATIONS = {
        ORIGINAL: 'original',
        VARIATION_1: 'Variation1',
    };

    private AB_TESTS = [
        ...(_featuresConfig?.abTests ?? []),
        {
            name: this.TEST_NAMES.LENNY_SPEED_DESKTOP,
            percentage: 100,
            variations: Object.values(this.DEFAULT_VARIATIONS),
            trigger: !uaParser.isMobile,
        },
        {
            name: this.TEST_NAMES.LENNY_SPEED_MOBILE,
            percentage: 100,
            variations: Object.values(this.DEFAULT_VARIATIONS),
            trigger: uaParser.isMobile,
        },
    ];

    private getTestsVariationsFromCache(): Record<string, string> {
        return storageRepository.getItemParsed('PiwikAbTesting');
    }

    public get tests() {
        return this.AB_TESTS;
    }

    public get isLennyOriginalSpeed(): boolean {
        const name = uaParser.isMobile
            ? this.TEST_NAMES.LENNY_SPEED_MOBILE
            : this.TEST_NAMES.LENNY_SPEED_DESKTOP;
        const variation = this.getTestsVariationsFromCache()?.[`variation:${name}`];

        return variation ? variation === this.DEFAULT_VARIATIONS.ORIGINAL : true;
    }
}

export const abTesting = new ABTesting();
